import type { AxiosError } from 'axios';
import { ApiError } from '../services/api-error';

function nestMessageToString(message: unknown): string | null {
  if (typeof message === 'string' && message.trim()) return message.trim();
  if (Array.isArray(message)) {
    const parts = message.filter((m) => typeof m === 'string') as string[];
    if (parts.length) return parts.join('; ');
  }
  return null;
}

/**
 * Централизованное извлечение сообщения об ошибке для показа пользователю.
 * Используйте в catch-блоках вместе с toast/snackbar.
 */
export function handleApiError(error: unknown, fallbackMessage: string): string {
  if (error instanceof ApiError) {
    const fromApi = nestMessageToString(error.message);
    if (fromApi) return fromApi;
  }
  if (error && typeof error === 'object' && 'isAxiosError' in error) {
    const axiosErr = error as AxiosError<{ message?: string | string[] }>;
    const nested = nestMessageToString(axiosErr.response?.data?.message);
    if (nested) return nested;
  }
  if (error instanceof Error) return error.message;
  return fallbackMessage;
}
